import { useEffect, useState, useRef } from "react";
import {
  getCombos,
  getProyectos,
  setProyecto,
  setPlantillaSencilla,
  updateProyecto,
} from "../componentes/api.js";
import VentanaCrear from "../comun/VentanaCrear.jsx";
import {
  Alert,
  Divider,
  FormGroup,
  FormControlLabel,
  Switch,
  TextField,
} from "@mui/material";
import BarraBotones from "../comun/BarraBotones.jsx";
import { FaFileMedical } from "react-icons/fa";
import { ButtonGroup, ToggleButton, Table } from "react-bootstrap";

const Nuevo = (props) => {
  const testRef = useRef(null);
  const scrollToElement = () => testRef.current.scrollIntoView();
  const [proyectos, setProyectos] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [cant, setCant] = useState(0);
  const [datos, setDatos] = useState({
    id: "",
    nbre: "",
    tipo: "",
    fechaIni: "",
    fechaFin: "",
    objetivoGral: "",
    objetivoEspecifico: "",
    correoDirector: "",
    estado: 1, //Avance del proyecto
    activo: true,
    idUsuario: props.idUsuario,
  });

  /** Para el manejo de la ventana de creación de tipos de proyectos**/
  const [mostrarCrear, setMostrarCrear] = useState(false);

  useEffect(() => {
    cargarCombos({ Tabla: "proyecto_tipo", Campo: "" }, "cboTipo");
    cargarProyectos();
  }, []);

  const asignarAvance = (valor) => {
    setDatos({ ...datos, ["estado"]: valor });
  };

  const asignarDato = (event) => {
    event.preventDefault();
    if (event.target.name === "activo") {
      setDatos({ ...datos, [event.target.name]: event.target.checked });
    } else {
      setDatos({ ...datos, [event.target.name]: event.target.value });
    }
  };

  const botones = (btn) => {
    if (btn === 0) {
      nuevo();
    } else if (btn === 1) {
      validarDatos();
    } else if (btn === 3) {
      exportar();
    } else if (btn === 4) {
      nuevo();
    }
  };

  const cargarCombos = async (datos, cbo) => {
    try {
      const response = await getCombos(datos);
      if (cbo === "cboTipo") {
        setTipos(response.data);
      }
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Combos",
        error,
      ]);
    }
  };

  const cargarProyectos = async () => {
    try {
      const response = await getProyectos();
      setProyectos(response.data);
      setCant(response.data.length);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Proyectos",
        error,
      ]);
    }
  };

  const exportar = () => {
    props.mostrarMsg(["OK, exportará los datos"]);
  };

  const grabarCampo = async (nbre) => {
    try {
      let plantilla = {
        tabla: "proyecto_tipo",
        nbre: nbre,
        activo: "1",
        idUsuario: props.idUsuario,
      };
      const response = await setPlantillaSencilla(plantilla);
      setDatos({ ...datos, tipo: response.data.Id });
      cargarCombos({ Tabla: "proyecto_tipo", Campo: "" }, "cboTipo");
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Grabar el Tipo de Proyecto",
        error,
      ]);
    }
  };

  const grabarRegistro = async () => {
    try {
      const response = await setProyecto(datos);
      setDatos({ ...datos, id: response.data.Id });
      cargarProyectos();
      props.asignarProyecto(response.data.Id);
      props.mostrarMsg(["Felicidades!!!", "Se ha creado el Proyecto"]);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Grabar el Proyecto ",
        error,
      ]);
    }
  };

  const mostrarVentanaCrear = (event) => {
    event.preventDefault();
    setMostrarCrear(true);
  };

  const mostrarRegistro = async (reg) => {
    setDatos({
      ...datos,
      id: reg.Id,
      nbre: reg.Nbre,
      tipo: reg.IdTipo,
      fechaIni: reg.FechaIni.toString().substring(0, 10),
      fechaFin: reg.FechaFin.toString().substring(0, 10),
      objetivoGral: reg.ObjetivoGral || "",
      objetivoEspecifico: reg.ObjetivoEspecifico || "",
      correoDirector: reg.CorreoDirector || "",
      estado: reg.Estado,
      activo: reg.Activo === "Activo" ? true : false,
      idUsuario: props.idUsuario,
    });
    props.asignarProyecto(reg.Id);
  };

  const modificarRegistro = async () => {
    try {
      await updateProyecto(datos);
      cargarProyectos();
      props.mostrarMsg(["Proyecto Modificado"]);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Modificar las Actividades del Proyecto",
        error,
      ]);
    }
  };

  const nuevo = () => {
    setDatos({
      id: "",
      nbre: "",
      tipo: "",
      fechaIni: "",
      fechaFin: "",
      objetivoGral: "",
      objetivoEspecifico: "",
      correoDirector: "",
      estado: 1, //Avance del proyecto
      activo: true,
      idUsuario: props.idUsuario,
    });
    props.asignarProyecto("");
    scrollToElement();
  };

  const validarDatos = () => {
    if (datos.nbre === "") {
      props.mostrarMsg(["Por favor digite el Nombre del Proyecto"]);
    } else if (datos.tipo === "") {
      props.mostrarMsg(["Por favor seleccione el Tipo de Proyecto"]);
    } else if (datos.fechaIni === "") {
      props.mostrarMsg(["Por favor digite la Fecha de Inicio del Proyecto"]);
    } else if (datos.fechaFin === "") {
      props.mostrarMsg(["Por favor digite la Fecha Final del Proyecto"]);
    } else if (datos.objetivoGral === "") {
      props.mostrarMsg(["Por favor digite el Objetivo General del Proyecto"]);
    } else if (datos.objetivoEspecifico === "") {
      props.mostrarMsg([
        "Por favor digite el Objetivo Especifico del Proyecto",
      ]);
    } else {
      if (datos.id === "") {
        grabarRegistro();
      } else {
        modificarRegistro();
      }
    }
  };

  return (
    <div className="container-fluid mt-3" ref={testRef}>
      <div className="row mt-3">
        <BarraBotones
          botones={botones}
          btnActivos={[true, true, false, true, true]}
        />
      </div>

      <div className="row card">
        <Alert severity="success">
          <strong>CREACION DE NUEVO PROYECTO</strong>
        </Alert>

        <div className="row mt-3 m-1">
          <TextField
            autoFocus={true}
            name="nbre"
            label="Nombre del nuevo Proyecto"
            className="form-control"
            type="text"
            value={datos.nbre}
            onChange={asignarDato}
          />
        </div>

        <div className="row mt-3">
          <div className="input-group form-floating mt-3">
            <select
              label="Tipo de Proyecto"
              name="tipo"
              className="form-select form-control"
              id="tipo"
              aria-label="tipoProyecto"
              value={datos.tipo}
              onChange={(event) => asignarDato(event)}
            >
              <option key="0" value="0">
                Por favor seleccione un Tipo de Proyecto...
              </option>
              {tipos.map((reg) => {
                return (
                  <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                    {" "}
                    {reg.Nbre}{" "}
                  </option>
                );
              })}
            </select>
            <button
              className="btn btn-primary"
              type="button"
              onClick={(event) => {
                mostrarVentanaCrear(event);
              }}
            >
              <FaFileMedical />
            </button>
          </div>
        </div>

        <div className="row mt-3 mb-3">
          <div className="col-sm-6">
            <TextField
              InputLabelProps={{ shrink: true }}
              style={{ marginTop: "10px" }}
              name="fechaIni"
              label="Fecha de Inicio"
              className="form-control"
              type="date"
              value={datos.fechaIni}
              onChange={asignarDato}
            />
          </div>
          <div className="col-sm-6">
            <TextField
              InputLabelProps={{ shrink: true }}
              style={{ marginTop: "10px" }}
              name="fechaFin"
              label="Fecha de Finalización"
              className="form-control"
              type="date"
              value={datos.fechaFin}
              onChange={asignarDato}
            />
          </div>
        </div>

        <Alert icon={false} severity="info">
          Objetivo Principal
        </Alert>

        <div className="row m-1">
          <TextField
            style={{ marginTop: "10px" }}
            name="objetivoGral"
            label="Objetivo Principal"
            className="form-control"
            multiline
            maxRows={8}
            value={datos.objetivoGral}
            onChange={asignarDato}
          />
        </div>

        <Alert icon={false} severity="info">
          Objetivo Específicos
        </Alert>

        <div className="row m-1">
          <TextField
            style={{ marginTop: "10px" }}
            name="objetivoEspecifico"
            label="Objetivo Especifico"
            className="form-control"
            multiline
            maxRows={8}
            value={datos.objetivoEspecifico}
            onChange={asignarDato}
          />
        </div>

        <div className="row mt-2 mb-3">
          <Alert severity="info">
            <p>Por favor registre una cuenta de correo electrónico</p>
            <p>
              Esta cuenta servirá para recibir los correos de alerta de cada
              registro de actividades que hagan los asesores y beneficiarios en
              el cumplimiento de sus funciones
            </p>
            <input
              name="correoDirector"
              className="form-control"
              value={datos.correoDirector}
              onChange={asignarDato}
            />
          </Alert>
        </div>

        <div className="row mt-2 mb-3">
          <h5>Avence del Proyecto</h5>
          <ButtonGroup>
            <ToggleButton
              key={1}
              id={`radio-1`}
              type="radio"
              variant={"outline-danger"}
              name="estado"
              value={1}
              checked={datos.estado === 1}
              onClick={(e) => asignarAvance(1)}
            >
              Sin Ejecución
            </ToggleButton>

            <ToggleButton
              key={2}
              id={`radio-2`}
              type="radio"
              variant={"outline-info"}
              name="estado"
              value={2}
              checked={datos.estado === 2}
              onClick={(e) => asignarAvance(2)}
            >
              En Ejecución
            </ToggleButton>

            <ToggleButton
              key={3}
              id={`radio-3`}
              type="radio"
              variant={"outline-success"}
              name="estado"
              value={3}
              checked={datos.estado === 3}
              onClick={(e) => asignarAvance(3)}
            >
              Finalizado
            </ToggleButton>
          </ButtonGroup>
        </div>

        <div className="row">
          <FormGroup>
            <FormControlLabel
              name="activo"
              control={
                <Switch
                  checked={datos.activo}
                  onChange={asignarDato}
                  inputProps={{ "aria-label": "Activo" }}
                />
              }
              label={
                datos.activo === true
                  ? "Estado: Proyecto ACTIVO"
                  : "Estado: Proyecto ANULADO"
              }
              labelPlacement="start"
            />
          </FormGroup>
        </div>
      </div>

      <Divider component="ul" />
      <div className="row mt-3">
        <BarraBotones
          botones={botones}
          btnActivos={[true, true, false, true, true]}
        />
      </div>
      <Divider component="ul" />

      <div className="row">
        <div className="row mt-2">
          <h3>Listado de Proyectos - Cantidad : {cant}</h3>
          <Table className="table table-hover table-bordered" responsive>
            <thead className="table-primary">
              <tr>
                <th scope="col"># Item</th>
                <th scope="col">Nombre</th>
                <th scope="col">Fecha de Inicio</th>
                <th scope="col">Fecha Final</th>
                <th scope="col">Avance</th>
                <th scope="col">Estado</th>
                <th scope="col">Acción</th>
              </tr>
            </thead>
            <tbody>
              {proyectos.map((reg, i) => {
                return (
                  <tr
                    className={reg.Activo === "Inactivo" ? "table-danger" : ""}
                    key={i}
                  >
                    <th> {i + 1} </th>
                    <th> {reg.Nbre} </th>
                    <th> {reg.FechaIni.toString().substring(0, 10)} </th>
                    <th> {reg.FechaFin.toString().substring(0, 10)} </th>
                    <th> {reg.NbreEstado} </th>
                    <th> {reg.Activo} </th>
                    <th>
                      {" "}
                      <a href="#divTop">
                        <button
                          className="btn btn-primary form-control"
                          onClick={(event) => {
                            mostrarRegistro(reg);
                          }}
                        >
                          Editar
                        </button>
                      </a>
                    </th>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>

      {mostrarCrear === true && (
        <VentanaCrear
          titulo={"TIPO DE PROYECTO"}
          grabarCampo={grabarCampo}
          mostrarCrear={mostrarCrear}
          setMostrarCrear={setMostrarCrear}
        />
      )}
    </div>
  );
};

export default Nuevo;
